import {MMQueryOptions} from 'lionheartland';


export class SODeleteOrganizationInvite {

  constructor(
    public uid: string,
    public predicate: string = null,
    public queryOptions: MMQueryOptions = new MMQueryOptions(),
  ) {
  }
}
